export default "__VITE_ASSET__b940394d__"